import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import useIdleLogout, { IDLE_MINUTES, IDLE_LOGOUT_KEY } from '../utils/useIdleLogout';
import { POOL_PREFIX } from '../utils/cognitoAuth';

// Mounted once inside the signed-in shell. Signs the admin out after
// IDLE_MINUTES without activity and shows a countdown for the last minute.
export default function IdleLogout() {
  const { user, logout } = useAuth();

  const onIdle = () => {
    try { localStorage.setItem(IDLE_LOGOUT_KEY, '1'); } catch { /* storage blocked */ }
    logout();
  };

  const { warning, secondsLeft, stay } = useIdleLogout({ onIdle, enabled: Boolean(user) });

  // When another tab signs out, this one follows instead of sitting on
  // patient data with no session behind it.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === `${POOL_PREFIX}.LastAuthUser` && !e.newValue) window.location.replace('/login');
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  if (!warning) return null;
  return (
    <>
      <div className="ops-idle__backdrop" />
      <div className="ops-idle" role="alertdialog" aria-modal="true" aria-labelledby="ops-idle-title" aria-describedby="ops-idle-text">
        <h2 id="ops-idle-title">Still there?</h2>
        <p id="ops-idle-text">
          You will be signed out in <b>{secondsLeft}</b> second{secondsLeft === 1 ? '' : 's'} because there has been no activity for almost {IDLE_MINUTES} minutes. This protects patient information on an unattended screen.
        </p>
        <div className="ops-actions">
          <button type="button" className="ops-btn ops-btn--primary" onClick={stay} autoFocus>Stay signed in</button>
          <button type="button" className="ops-btn" onClick={onIdle}>Sign out now</button>
        </div>
      </div>
    </>
  );
}
